export const strings = {
    "saveBtnTooltip": "Aggiungi alla lista",
    "deleteAllBtnTooltip": "Cancella la lista",
    "deleteBtnTooltip": "Elimina dalla lista",
    "relatedProductsTitle": "Guarda anche:", 
}